import { render, staticRenderFns } from "./SequenceBuilder.vue?vue&type=template&id=11c8ba24&scoped=true"
import script from "./SequenceBuilder.vue?vue&type=script&lang=js"
export * from "./SequenceBuilder.vue?vue&type=script&lang=js"
import style0 from "./SequenceBuilder.vue?vue&type=style&index=0&id=11c8ba24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c8ba24",
  null
  
)

export default component.exports